// extracted by mini-css-extract-plugin
module.exports = {"iframe":"CardDetailsPane__iframe__35QOs"};